import type { IconNode } from '../types';

/**
 * @name candlestick-lit
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnMtMiAxLjktMiAzIC45IDIgMiAyIDItLjkgMi0yLTItMy0yLTMiIC8+CiAgPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iMTEiIHg9IjEwIiB5PSIxMSIgLz4KICA8cGF0aCBkPSJtMTUgMTMtMS0yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/candlestick-lit
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const candlestickLit: IconNode = [
  ['path', { d: 'M12 2s-2 1.9-2 3 .9 2 2 2 2-.9 2-2-2-3-2-3', key: 'n2h0sg' }],
  ['rect', { width: '4', height: '11', x: '10', y: '11', key: '1t944q' }],
  ['path', { d: 'm15 13-1-2', key: '1cbcw3' }],
];

export default candlestickLit;
